import React from 'react'
import { NodeCard, MessageSelect, EchartsSetting } from '../components/NodeCard'
import { UploadIconField } from '../components/UploadIcon'

const paramSchema = () => ({
  type: 'object',
  properties: {
    model: {
      title: '模型',
      type: 'object',
      fieldType: 'model',
      properties: {},
    },
    icon: {
      title: '图标',
      type: 'string'
    },
    message: {
      title: '显示信息选择',
      type: 'array',
      items: {
        type: 'string',
        name: '信息'
      },
    },
    bgColor: {
      type: 'string',
      title: '卡片颜色',
      fieldType: 'color'
    },
    color: {
      type: 'string',
      title: '文字颜色',
      fieldType: 'color'
    },
    chart: {
      type: 'string',
      title: '图表'
    },
    lookbtn: {
      type: 'boolean',
      title: '是否显示按钮'
    }
  },
  required: [ 'model' ],
  form: [ 'model', 
    { key: 'icon', component: UploadIconField }, 
    { key: 'message', component: MessageSelect }, 
    'bgColor', 
    'color', 
    'lookbtn',
    { key: 'chart', component: EchartsSetting },
    '*' 
  ]
})


const NodeCardSetting = {
  title: '资产卡片配置',
  category: '版本兼容',
  icon: require('../icon/资产卡片配置.svg'),
  disabled: true,
  explain: '现场监屏使用，兼容组件',
  component: NodeCard,
  paramSchema
}


export default NodeCardSetting
